import React from 'react';
import useGeneralStyles from 'apps/Pdf/styles/general';
import Grid from '@material-ui/core/Grid';
import useStyles from 'apps/Pdf/components/common/styles/Article';

interface Props {
  children: React.ReactNode;
  numbered?: boolean;
  levelUp?: boolean;
  topLevel?: boolean;
}

const ListItem = (props: Props) => {
  const styles = useGeneralStyles();
  const classes = useStyles();

  return (
    <Grid container className={`${classes.root} customNumberedItem`} alignItems="flex-start">
      <Grid
        item
        xs={1}
        className={`${styles.regularText}${props.numbered ? ' numbered' : ''}${
          props.levelUp ? ' levelUp' : ''
        }${props.topLevel ? ' topLevel' : ''}`}
      />
      <Grid item xs={11} className={`${styles.regularText}`}>
        {props.children}
      </Grid>
    </Grid>
  );
};

export default ListItem;
